import React, { useState } from 'react';
import changePassword from './../images/edit-line.svg';
import backIcon from '../images/close-line.svg';
import {
  getAuth,
  reauthenticateWithCredential,
  updatePassword,
  EmailAuthProvider,
} from 'firebase/auth';
import { useTranslation } from '../i18n';
import PasswordInput from './PasswordInput';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ChangePassword = ({ showNotification }) => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [modalIsOpen, setIsOpen] = useState(false);
  const [updatingPassword, setUpdatingPassword] = useState(false);

  function resetFields() {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  }

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
    resetFields();
  }

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      showNotification(t.passwordmissmatch);
      return;
    }
    const auth = getAuth();
    const user = auth.currentUser;
    setUpdatingPassword(true);
    logEvent(analytics, 'account_settings_change_password');

    if (!user) {
      showNotification('User not logged in.');
      return;
    }

    try {
      // Re-authenticate the user (optional but recommended)
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword,
      );
      await reauthenticateWithCredential(user, credential);

      // Update the password
      await updatePassword(user, newPassword);
      showNotification(t.passwordUpdateMessage);
      closeModal();
    } catch (error) {
      showNotification(t.passwordErrorMessage + ' ' + error.message);
    } finally {
      setUpdatingPassword(false);
    }
  };

  return [
    <div className="row-item" key="delete-account">
      <img height={24} width={24} alt={t.deleteaccount} src={changePassword} />
      <div
        className="link"
        onClick={() => openModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openModal();
          }
        }}
        tabIndex={0}
      >
        {t.changepassword}
      </div>
    </div>,

    modalIsOpen && (
      <div
        className="dialog-content fullscreen-overlay"
        key="delete-account-ocerlay"
      >
        <div className="fullscreen-container" tabIndex={-1}>
          <button
            className={`fullscreen-close ${updatingPassword ? 'pt-65' : null}`}
            onClick={closeModal}
            disabled={updatingPassword}
          >
            <img src={backIcon} width={42} height={42} alt="Close icon" />
            {t.close}
          </button>

          <div className="card-wrapper">
            <div className="card">
              <h3>{t.changepassword}</h3>
              <div className="form">
                <div className="pt-65">{t.passworddetails}</div>
                <PasswordInput
                  labelName={t.currentPassword}
                  id="password"
                  value={currentPassword}
                  required={true}
                  onChangeFunction={(e) => setCurrentPassword(e.target.value)}
                />
                <PasswordInput
                  labelName={t.newPassword}
                  id="newPassword"
                  value={newPassword}
                  required={true}
                  onChangeFunction={(e) => setNewPassword(e.target.value)}
                />
                <PasswordInput
                  labelName={t.confirmpasswordLabel}
                  id="confirmPassword"
                  value={confirmPassword}
                  required={true}
                  onChangeFunction={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => handleChangePassword()}
                  disabled={
                    updatingPassword ||
                    newPassword !== confirmPassword ||
                    currentPassword === '' ||
                    newPassword === ''
                  }
                >
                  {t.changepassword}
                </button>
              </div>
            </div>
          </div>

          <div className="btn-group-wrapper">
            <div className="btn-group">
              <button
                className="btn btn-secondary w-100"
                onClick={() => closeModal()}
                disabled={updatingPassword}
              >
                {t.cancel}
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
  ];
};

export default ChangePassword;
